import React from "react"
import {Tabs, Tab} from "@mui/material";
import {BVATabsContainer} from "./styled";
import Box from "@mui/material/Box";


export default function BVATabs({
  items = [],
  itemLabel = "label",
  itemValue = "value",
  onChange = () => ({}),
  value
}) {
  // Methods
  const handleOnChange = (event, value) => {
    onChange(value)
  }


  return (
    <BVATabsContainer>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs onChange={handleOnChange} value={value}>
          {items.map((item, index) => (
            <Tab
              key={index}
              classes={{ selected: "bva-select--tab__selected" }}
              label={item[itemLabel]}
              value={item[itemValue]} />
          ))}
        </Tabs>
      </Box>
    </BVATabsContainer>
  )
}